export default __webpack_public_path__ + "static/media/icon_positionJd_fold_arrow.d408db0d.svg";